(function () {
  var DATA = {
    productId: '',
    unit: '',
    unitSingle: '',
    qtyLabel: 'Aantal',
    unitPriceOnly: false,
    ownsMainPrice: false,
    ownsKind: '',
    prices: {},
  };

  /* Prijsdata staat in .product-details [data-bbv-data] (morpht mee in main).
     Stabiel id="bbv-data" matchte de oude node; de JSON bleef die van het
     vorige product. Het IIFE in theme.liquid herleest deze node. */
  function livePriceDataNode() {
    return document.querySelector('.product-details [data-bbv-data]');
  }

  function liveProductIdFromDom() {
    var el = document.querySelector('.product-details .bbv-qty-price[data-product-id]');
    if (!el) return '';
    return el.getAttribute('data-product-id') || '';
  }

  function reloadData() {
    var node = livePriceDataNode();
    if (!node) return;
    try {
      var raw = JSON.parse(node.textContent);
      var jsonId = raw.productId != null ? String(raw.productId) : '';
      var fromDom = liveProductIdFromDom();
      var jsonStale = Boolean(fromDom && jsonId && fromDom !== jsonId);
      var nextId = fromDom || jsonId;
      var productChanged = Boolean(DATA.productId && nextId && DATA.productId !== nextId);
      var eenheid = raw.eenheid || {};
      DATA.unit = eenheid.unit || DATA.unit;
      DATA.unitSingle = eenheid.unitSingle || DATA.unitSingle;
      DATA.qtyLabel = eenheid.qtyLabel || DATA.qtyLabel;
      DATA.unitPriceOnly = eenheid.priceOnly === true;
      if (jsonStale) {
        DATA.ownsMainPrice = false;
        DATA.ownsKind = '';
        DATA.prices = {};
      } else {
        DATA.ownsMainPrice = raw.ownsMainPrice === true;
        DATA.ownsKind = raw.ownsKind || '';
        DATA.prices = raw.prices || {};
      }
      DATA.productId = nextId || DATA.productId;
      if (productChanged) {
        lastQuantity = null;
        lastVariantId = null;
        pendingVariantId = null;
        staleConfiguratorCents = true;
      }
    } catch (e) {
      /* fallback hierboven */
    }
  }

  reloadData();

  var LAYOUT = {
    ctaWhenMore: 'Alles in winkelwagen',
  };

  var container = null;
  var main = null;
  var observer = null;
  var lastQuantity = null;
  var applied = false;
  var lastVariantId = null;
  var pendingVariantId = null;
  var staleConfiguratorCents = false;

  /* Alles wat wij zelf in de buybox veranderen loopt hierdoorheen. Zonder dat
     ziet de observer onze eigen wijzigingen aan voor een morph en herbouwt hij
     eindeloos door — een vlag helpt niet, want de callback komt pas ná apply(). */
  function silently(fn) {
    if (observer) observer.disconnect();
    try {
      fn();
    } finally {
      if (observer && main) observer.observe(main, { childList: true, subtree: true });
    }
  }

  /* Zelfde vorm als het thema: geen valutateken, hele bedragen op ",-". Eén formatter, niet per bedrag. */
  var moneyFormat = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  function money(cents) {
    return moneyFormat.format(cents / 100).replace(/,00$/, ',-');
  }

  function currentVariantId() {
    var root = document.querySelector('.product-details') || document;
    var fromForm = '';
    var nodes = root.querySelectorAll('form.shopify-product-form input[name="id"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('sticky-add-to-cart, .sticky-add-to-cart')) continue;
      if (nodes[i].disabled) continue;
      if (nodes[i].value) {
        fromForm = String(nodes[i].value);
        break;
      }
    }
    if (fromForm) {
      if (!pendingVariantId || pendingVariantId === fromForm || DATA.prices[fromForm] != null) {
        pendingVariantId = null;
        return fromForm;
      }
      return pendingVariantId;
    }
    return pendingVariantId || '';
  }

  function unitCentsFromQtyRow() {
    var el = document.querySelector('.product-details .bbv-qty-price [data-bbv-unit-cents]');
    if (!el) return null;
    var cents = parseInt(el.getAttribute('data-bbv-unit-cents'), 10);
    return cents > 0 ? cents : null;
  }

  function unitCents() {
    var fromRow = unitCentsFromQtyRow();
    if (fromRow != null) return fromRow;
    var id = currentVariantId();
    if (id && DATA.prices[id] != null) return DATA.prices[id];
    return null;
  }

  /* Alleen lezen wat de configurator al heeft berekend (formule/cart).
     Geen oppervlakte × m² in het thema. totalProductPrice is extra producten,
     niet het hoofdproduct; variant.price is op maatwerk vaak de m²-prijs. */
  function parseMajorToCents(major) {
    if (typeof major === 'string') {
      major = parseFloat(String(major).replace(',', '.'));
    }
    if (typeof major !== 'number' || !isFinite(major) || major <= 0) return null;
    return Math.round(major * 100);
  }

  function configuratorProductCents() {
    if (!configuratorOwnsMainPrice()) return null;
    /* Na morph hoort de vorige formule niet meer bij deze variant. */
    if (staleConfiguratorCents) return null;
    var summary = liveSummary();
    var fromDom = summary && summary.getAttribute('data-configurator-main-line-cents');
    if (fromDom) {
      var parsedDom = parseInt(fromDom, 10);
      if (parsedDom > 0) return parsedDom;
    }
    var pricing = window.ProductConfiguratorPricing;
    if (
      pricing &&
      typeof pricing.mainLineCents === 'number' &&
      isFinite(pricing.mainLineCents) &&
      pricing.mainLineCents > 0
    ) {
      return Math.round(pricing.mainLineCents);
    }
    /* Alleen de formule-override is het hoofdlijnbedrag. validatedPrice zonder
       override is een toeslag; totalProductPrice is extra producten / m²-fout. */
    if (pricing && pricing.hasBasePriceOverride === true) {
      var fromWindow = parseMajorToCents(pricing.validatedPrice);
      if (fromWindow != null) return fromWindow;
    }
    var hidden = document.querySelector(
      'form.shopify-product-form input[name="properties[_configurator_validated_price]"]'
    );
    var mode = document.querySelector(
      'form.shopify-product-form input[name="properties[_configurator_price_mode]"]'
    );
    if (mode && mode.value === 'override') {
      return parseMajorToCents(hidden && hidden.value);
    }
    return null;
  }

  /* Zelfde vlag als Liquid (snapshot in #bbv-data). Geen DOM-:has. */
  function configuratorOwnsMainPrice() {
    return DATA.ownsMainPrice === true;
  }

  function productLineCents() {
    if (configuratorOwnsMainPrice()) {
      return configuratorProductCents();
    }
    var piece = unitCents();
    if (piece == null) return null;
    return piece * currentQuantity();
  }

  function configuratorQuantityField() {
    return document.querySelector('input[data-is-quantity-field="true"]');
  }

  function currentQuantity() {
    if (configuratorOwnsMainPrice()) {
      var cfg = configuratorQuantityField();
      if (cfg) {
        var fromCfg = parseInt(cfg.value, 10);
        if (fromCfg > 0) return fromCfg;
      }
    }
    var field = document.querySelector('.bbv-qty-row [name="quantity"]');
    var value = field ? parseInt(field.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function reset() {
    if (!container) return;

    container.querySelectorAll('[data-bbv-cta]').forEach(function (cta) {
      deepest(cta).textContent = cta.getAttribute('data-bbv-label') || '';
      cta.removeAttribute('data-bbv-cta');
      cta.removeAttribute('data-bbv-label');
    });
  }

  /* Elke morph zet een vers veld met waarde 1. Het gekozen aantal leeft
     buiten de DOM, zodat wisselen van variant het niet weggooit. */
  function restoreThemeQuantity() {
    var nodes = document.querySelectorAll('.bbv-qty-row [name="quantity"]');
    for (var i = 0; i < nodes.length; i++) {
      restoreQuantity(nodes[i]);
    }
  }

  function restoreQuantity(field) {
    if (!field) return;
    if (lastQuantity == null) {
      lastQuantity = parseInt(field.value, 10) || 1;
    }
    setFieldValue(field, lastQuantity);
  }

  /* Na «In winkelwagen» liften de kiezers van «Maak je vloer compleet» mee in één verzoek
     (cart-batch.js) en maken daarna elk hun keuze leeg. Zolang dat loopt blijft het Totaal staan;
     daarna één keer bijwerken, anders zakt het in stappen (eerst 1 pak, dan per kiezer). */
  var BATCH_DONE_EVENT = 'hds:cart-batch-done';
  var BATCH_HOLD_MS = 15000;
  var heldSince = 0;
  var heldRender = false;
  var heldReset = false;

  function batchBusy() {
    if (!document.documentElement.hasAttribute('data-hds-cart-batch')) {
      heldSince = 0;
      return false;
    }
    if (!heldSince) heldSince = Date.now();
    // Noodrem: blijft de markering hangen, dan niet eeuwig een verouderd Totaal tonen.
    return Date.now() - heldSince < BATCH_HOLD_MS;
  }

  function onBatchDone() {
    heldSince = 0;
    var reset = heldReset;
    var render = heldRender;
    heldReset = false;
    heldRender = false;
    if (reset) resetQuantityNow();
    else if (render) silently(renderSummary);
  }

  function resetQuantityAfterAdd(event) {
    var addedId = event && event.detail && event.detail.productId;
    var currentId = liveProductIdFromDom() || DATA.productId;
    if (addedId && currentId && String(addedId) !== String(currentId)) return;

    // De kiezers bieden hun regels pas aan op het CartAddEvent dat hierna komt.
    setTimeout(function () {
      if (batchBusy()) heldReset = true;
      else resetQuantityNow();
    }, 0);
  }

  function resetQuantityNow() {
    lastQuantity = 1;
    silently(function () {
      var nodes = document.querySelectorAll('.bbv-qty-row [name="quantity"]');
      for (var i = 0; i < nodes.length; i++) {
        setFieldValue(nodes[i], 1);
      }
      var cfg = configuratorQuantityField();
      if (cfg) setFieldValue(cfg, 1);
      renderSummary();
    });
  }

  function setFieldValue(field, value) {
    if (!field) return;
    if (field.tagName === 'SELECT') {
      var exists = Array.prototype.some.call(field.options, function (option) {
        return option.value === String(value);
      });
      if (!exists) return;
    }
    field.value = String(value);
  }

  function configuratorFieldNumber(names) {
    for (var i = 0; i < names.length; i++) {
      var root = document.querySelector(
        '.configurator-field[data-field-name="' + names[i] + '"]'
      );
      if (!root) continue;
      var field = root.querySelector(
        'input.configurator-field-input, input[type="number"], input[type="text"]'
      );
      if (!field || !field.value) continue;
      var n = parseFloat(String(field.value).replace(',', '.'));
      if (n > 0) return n;
    }
    return null;
  }

  /* Alleen voor het label in het overzicht — nooit vermenigvuldigen met de
     m²-prijs. 80×40 cm is 0,32 m², niet "1 m²" van het aantalfeld. */
  function configuredAreaM2() {
    var lengthCm = configuratorFieldNumber(['Lengte', 'lengte', 'Length', 'length']);
    var widthCm = configuratorFieldNumber(['Breedte', 'breedte', 'Width', 'width']);
    if (!lengthCm || !widthCm) return null;
    var area = (lengthCm * widthCm) / 10000;
    return area > 0 ? area : null;
  }

  function areaPhrase(area) {
    return (
      new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(area) + ' m²'
    );
  }

  function summaryLineLabel(quantity) {
    var area = configuredAreaM2();
    if (area != null) {
      var phrase = areaPhrase(area);
      return quantity > 1 ? quantity + ' × ' + phrase : phrase;
    }
    return unitPhrase(quantity);
  }

  function unitPhrase(quantity) {
    /* Shopify-prijseenheid die niet gelijk is aan één variant (Squid: 20 cm, prijs
       per m) is geen besteleenheid: 8 stuks, niet "8 m". */
    var word = DATA.unitPriceOnly ? '' : quantity === 1 ? DATA.unitSingle : DATA.unit;
    /* Zonder producteenheid (verf, tape, …) geen kaal cijfer in het overzicht. */
    if (!word) word = quantity === 1 ? 'stuk' : 'stuks';
    return quantity + ' ' + word;
  }

  /* De diepste span met de tekst erin: het thema nest zijn knoplabel een paar
     lagen diep voor de "toegevoegd"-animatie. Daar de tekst zetten laat die
     structuur heel. */
  function deepest(el) {
    while (el.children.length === 1) el = el.children[0];
    return el;
  }

  /* Standaard blijft "In winkelwagen". Alleen als er toebehoren of cadeaus
     mee gaan dekt "Alles" de lading. */
  function ctaLabel(container, variant) {
    var cta = container.querySelector('add-to-cart-component .add-to-cart-text__content');
    /* De vaste balk onderaan voegt hetzelfde toe; daar staat de tekst in de eerste span
       (ernaast het aantal), op de telefoon alleen voor schermlezers zichtbaar. */
    var sticky = document.querySelector('.sticky-add-to-cart__button .add-to-cart-text__content > span:first-child');
    var gifts = chosenGifts();
    var extra = variant && variant.ctaWhenMore;
    var more = extra && (chosenExtras().count > 0 || gifts.freeNames.length > 0 || gifts.paidNames.length > 0);

    [cta, sticky].forEach(function (el) {
      if (!el) return;
      if (!el.hasAttribute('data-bbv-cta')) {
        el.setAttribute('data-bbv-cta', '');
        el.setAttribute('data-bbv-label', deepest(el).textContent);
      }
      var text = more ? extra : el.getAttribute('data-bbv-label') || '';
      if (deepest(el).textContent !== text) deepest(el).textContent = text;
    });
  }

  function liveSummary() {
    if (container) {
      var nested = container.querySelector('.bbv-summary');
      if (nested) return nested;
    }
    return document.querySelector('.product-details .bbv-summary');
  }

  /* Montageproducten + ophoging. Niet elke .button-option.selected: maatoptie,
     kleur en verborgen advies-opties gaven +98,- zonder keuze (SHO-9127). */
  function adviceBundleLooksChosen(row) {
    var check = row.querySelector('input[type="checkbox"]');
    if (check && !check.checked) return false;
    var step = row.closest('.config-step');
    var pill = step && step.querySelector('.step-summary-advice-pill-text');
    if (!pill) return true;
    var text = (pill.textContent || '').trim();
    if (!text || /^bekijk advies$/i.test(text) || /^kies\b/i.test(text)) return false;
    return /\d/.test(text);
  }

  function chosenConfiguratorExtras() {
    var cents = 0;
    var count = 0;

    document.querySelectorAll('.advice-bundle-card__row--selected').forEach(function (row) {
      if (!adviceBundleLooksChosen(row)) return;
      var field = row.querySelector('.advice-bundle-card__qty-input');
      var quantity = field ? parseInt(field.value, 10) || 1 : 1;
      if (quantity < 1) return;
      var unit = parseInt(row.getAttribute('data-price'), 10) || 0;
      if (!unit) return;
      cents += unit * quantity;
      count += quantity;
    });

    document.querySelectorAll('.config-step[data-step-box]').forEach(function (step) {
      var selected = step.querySelectorAll(
        ':scope > .step-content > .configurator-field > .configurator-button-group > .button-option.selected'
      );
      if (!selected.length) {
        selected = step.querySelectorAll('.button-option.selected');
      }
      if (!selected.length) return;
      var line = 0;
      var allCalc = true;
      selected.forEach(function (option) {
        var calc = parseFloat(option.getAttribute('data-calculated-price'));
        if (!isFinite(calc) || calc < 0) allCalc = false;
        else line += Math.round(calc * 100);
      });
      if (!allCalc || line <= 0) {
        var label = step.querySelector('.step-header-selected');
        var text = label && !label.hidden ? String(label.textContent || '') : '';
        var parts = text.split('·');
        line =
          parts.length > 1
            ? parseMajorToCents(parts[parts.length - 1].replace(/€/g, '').replace(/,-$/, '').trim()) || 0
            : 0;
      }
      if (line <= 0) return;
      cents += line;
      count += selected.length;
    });

    document.querySelectorAll('.configurator-field[data-field-type="product"] .button-option.selected').forEach(function (option) {
      if (option.closest('.advice-bundle-card')) return;
      if (option.closest('.config-step[data-step-box]')) return;
      if (!option.getClientRects().length) return;
      var qtyField = option.querySelector('input.configurator-quantity-input, input[type="number"]');
      var quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
      if (quantity < 1) return;
      var raw = option.getAttribute('data-price-value');
      if (!raw) return;
      var unit = Math.round(parseFloat(String(raw).replace(',', '.')) * 100);
      if (!unit) return;
      cents += unit * quantity;
      count += quantity;
    });
    return { cents: cents, count: count };
  }

  /* Wat de klant heeft aangevinkt in het toebehoren-blok of de configurator.
     Prijs en aantal staan op de rij zelf. */
  /* `cents`/`count` zijn alles samen (voor het Totaal en de knoptekst); `lines` zijn
     kiezers met een eigen regel, `generic` is wat als "N artikelen toebehoren" telt. */
  function chosenExtras() {
    var cents = 0;
    var count = 0;
    var lines = [];
    document.querySelectorAll('variant-additional-products [data-vap-item]').forEach(function (item) {
      var check = item.querySelector('[data-vap-check]');
      if (!check || !check.checked) return;
      var field = item.querySelector('[data-vap-qty]');
      var quantity = field ? parseInt(field.value, 10) || 1 : 1;
      cents += (parseInt(item.getAttribute('data-price'), 10) || 0) * quantity;
      count += quantity;
    });
    /* Losse kiezers (ondervloer, SHO-11389) zetten hun keuze als data op zichzelf.
       Met `data-bbv-extra-label` krijgen ze een eigen regel ("1 rol ondervloer"). */
    document.querySelectorAll('[data-bbv-extra]').forEach(function (el) {
      var lineCents = parseInt(el.getAttribute('data-bbv-extra-cents'), 10) || 0;
      var lineCount = parseInt(el.getAttribute('data-bbv-extra-count'), 10) || 0;
      var label = el.getAttribute('data-bbv-extra-label');
      if (label && lineCount > 0) {
        lines.push({
          label: label,
          cents: lineCents,
          count: lineCount,
          key: extraKey(el),
          id: el.getAttribute('data-bbv-extra-id') || '',
        });
        return;
      }
      cents += lineCents;
      count += lineCount;
    });
    var cfg = chosenConfiguratorExtras();
    var generic = { cents: cents + cfg.cents, count: count + cfg.count };
    var own = lines.reduce(
      function (sum, line) {
        return { cents: sum.cents + line.cents, count: sum.count + line.count };
      },
      { cents: 0, count: 0 }
    );
    return {
      cents: generic.cents + own.cents,
      count: generic.count + own.count,
      generic: generic,
      lines: lines,
    };
  }

  function chosenGifts() {
    var freeNames = [];
    var paidNames = [];
    var paidCents = 0;
    document.querySelectorAll('free-gifts [data-fg-item]').forEach(function (item) {
      var check = item.querySelector('[data-fg-check]');
      var name = item.querySelector('[data-fg-name]');
      if (!check || !check.checked || !name) return;
      var label = name.textContent.split(' - ')[0].trim();
      if (item.getAttribute('data-is-free') === 'true') {
        freeNames.push(label);
        return;
      }
      paidNames.push(label);
      paidCents += parseInt(item.getAttribute('data-price'), 10) || 0;
    });
    return { freeNames: freeNames, paidNames: paidNames, paidCents: paidCents };
  }

  /* Vaste sleutel per kiezer, zodat zijn regel na het herbouwen dezelfde blijft (rollende cijfers). */
  var extraKeys = new WeakMap();
  var nextExtraKey = 0;
  function extraKey(el) {
    if (!extraKeys.has(el)) extraKeys.set(el, 'extra-' + nextExtraKey++);
    return extraKeys.get(el);
  }

  /* Rollende cijfers en oplichten (rolling-digits.js, ontwerp Y4) zodra de kiezers die geladen
     hebben; zonder staat er gewoon de nieuwe tekst. */
  function setNumber(el, text) {
    if (window.HDSRoll) window.HDSRoll.roll(el, text);
    else el.textContent = text;
  }

  function summaryRow(label, value, valueClass, key) {
    var row = document.createElement('div');
    row.className = 'bbv-summary__row';
    if (key) row.setAttribute('data-bbv-key', key);
    var left = document.createElement('span');
    left.className = 'bbv-summary__row-label';
    left.textContent = label;
    var right = document.createElement('span');
    right.className = valueClass || '';
    right.textContent = value;
    row.appendChild(left);
    row.appendChild(right);
    return row;
  }

  function qtyRowShowsPrice() {
    return Boolean(document.querySelector('.bbv-qty-row[data-bbv-qty-price="true"]'));
  }

  /* Stukprijs staat al bij aantal (thema-rij of configurator-aantalveld)
     of in een prijsuitleg-veld. */
  function configuratorPriceSummary() {
    return document.querySelector('.product-details [data-field-type="price_summary"]');
  }

  function linePriceAlreadyOnScreen() {
    if (qtyRowShowsPrice()) return true;
    if (DATA.ownsKind === 'quantity' || DATA.ownsKind === 'price_summary') return true;
    if (configuratorQuantityField()) return true;
    return Boolean(configuratorPriceSummary());
  }

  function summaryAddsInfo(extras, gifts, quantity, totalCents) {
    if (quantity > 1) return true;
    if (extras.count > 0) return true;
    if (gifts.freeNames.length > 0 || gifts.paidNames.length > 0) return true;
    if (!linePriceAlreadyOnScreen()) return true;
    /* Prijsuitleg toont de koopprijs (vaak ≠ catalogus p/m²). Totaal is dan herhaling. */
    if (DATA.ownsKind === 'price_summary' || configuratorPriceSummary()) return false;
    var piece = unitCents();
    if (piece != null && totalCents != null && totalCents !== piece) return true;
    return false;
  }

  function renderSummary() {
    if (batchBusy()) {
      heldRender = true;
      return;
    }
    var extras = chosenExtras();
    var gifts = chosenGifts();
    var cents = productLineCents();
    var totalCents = cents == null ? null : cents + extras.cents + gifts.paidCents;
    syncSticky(totalCents);

    var summary = liveSummary();
    if (!summary) return;

    if (cents == null) {
      if (linePriceAlreadyOnScreen()) {
        summary.hidden = true;
        summary.classList.add('bbv-summary--omit');
        summary.classList.remove('bbv-summary--pending');
        summary.classList.remove('bbv-summary--show');
        summary.setAttribute('aria-hidden', 'true');
        return;
      }
      summary.hidden = false;
      summary.classList.add('bbv-summary--pending');
      summary.classList.remove('bbv-summary--omit');
      summary.classList.remove('bbv-summary--show');
      summary.setAttribute('aria-hidden', 'true');
      return;
    }

    var quantity = currentQuantity();
    var split = extras.count > 0 || gifts.freeNames.length > 0 || gifts.paidNames.length > 0;

    if (!summaryAddsInfo(extras, gifts, quantity, totalCents)) {
      summary.hidden = true;
      summary.classList.add('bbv-summary--omit');
      summary.classList.remove('bbv-summary--pending');
      summary.classList.remove('bbv-summary--show');
      summary.setAttribute('aria-hidden', 'true');
      ctaLabel(container, LAYOUT);
      return;
    }

    summary.hidden = false;
    summary.classList.add('bbv-summary--show');
    summary.classList.remove('bbv-summary--pending');
    summary.classList.remove('bbv-summary--omit');
    summary.removeAttribute('aria-hidden');

    var lineLabel = summaryLineLabel(quantity);

    var lines = summary.querySelector('.bbv-summary__lines');
    var wanted = [{ key: 'main', label: lineLabel, value: money(cents) }];
    extras.lines.forEach(function (line) {
      wanted.push({ key: line.key, label: line.label, value: '+ ' + money(line.cents), id: line.id });
    });
    if (extras.generic.count > 0) {
      wanted.push({
        key: 'generic',
        label: extras.generic.count + (extras.generic.count === 1 ? ' artikel' : ' artikelen') + ' toebehoren',
        value: '+ ' + money(extras.generic.cents),
      });
    }
    if (gifts.paidNames.length) {
      wanted.push({ key: 'gifts-paid', label: gifts.paidNames.join(' en '), value: '+ ' + money(gifts.paidCents) });
    }
    if (gifts.freeNames.length) {
      wanted.push({ key: 'gifts-free', label: gifts.freeNames.join(' en '), value: 'Gratis', valueClass: 'bbv-summary__free' });
    }
    syncRows(lines, wanted);

    summary.classList.toggle('bbv-summary--split', split);

    setNumber(summary.querySelector('.bbv-summary__total-sum'), money(totalCents));

    ctaLabel(container, LAYOUT);
  }

  /* Regels op hun plek bijwerken in plaats van opnieuw opbouwen. renderSummary draait een paar
     keer per klik; een bedrag dat uit de pagina gaat en terugkomt, breekt zijn rol af en springt
     naar het eind (rolling-digits.js, ontwerp Y4). */
  function syncRows(lines, wanted) {
    var existing = {};
    Array.prototype.forEach.call(lines.children, function (row) {
      var key = row.getAttribute('data-bbv-key');
      if (key) existing[key] = row;
    });
    wanted.forEach(function (want, i) {
      var row = existing[want.key];
      delete existing[want.key];
      if (!row) row = summaryRow(want.label, '', want.valueClass, want.key);
      var label = row.firstElementChild;
      var value = row.lastElementChild;
      if (label.textContent !== want.label) label.textContent = want.label;
      if (want.valueClass) {
        value.className = want.valueClass;
        value.textContent = want.value;
      } else {
        setNumber(value, want.value);
      }
      // Ander product in dezelfde kiezer: de regel licht kort op (niet bij − of +).
      var before = row.getAttribute('data-bbv-id') || '';
      if (want.id && before && before !== want.id && window.HDSRoll) window.HDSRoll.flash(row);
      if (want.id) row.setAttribute('data-bbv-id', want.id);
      else row.removeAttribute('data-bbv-id');
      if (lines.children[i] !== row) lines.insertBefore(row, lines.children[i] || null);
    });
    Object.keys(existing).forEach(function (key) {
      existing[key].remove();
    });
    // Regels zonder sleutel (van vóór dit script) weg.
    Array.prototype.slice.call(lines.children, wanted.length).forEach(function (row) {
      row.remove();
    });
  }

  function syncSticky(totalCents) {
    var el = document.querySelector('[data-bbv-sticky-sum]');
    if (!el) return;
    setNumber(el, totalCents == null ? '' : money(totalCents));
  }

  function observeDetails() {
    var next = document.querySelector('.product-details');
    if (!observer || !next) return;
    if (main === next) return;
    main = next;
    observer.disconnect();
    observer.observe(main, { childList: true, subtree: true });
  }

  function rememberVariantPrice(resource) {
    if (!resource || resource.id == null || resource.price == null) return;
    var cents = typeof resource.price === 'number' ? resource.price : parseInt(resource.price, 10);
    if (!cents || cents < 0) return;
    if (resource.productId != null && DATA.productId && String(resource.productId) !== DATA.productId) {
      return;
    }
    DATA.prices[String(resource.id)] = cents;
  }

  function noteVariantId(id) {
    if (!id || id === lastVariantId) return;
    if (lastVariantId) staleConfiguratorCents = true;
    lastVariantId = id;
  }

  function onVariantMorphed(resource) {
    reloadData();
    if (resource && resource.id != null) {
      rememberVariantPrice(resource);
      pendingVariantId = String(resource.id);
    } else {
      pendingVariantId = null;
    }
    noteVariantId(pendingVariantId || currentVariantId());
    observeDetails();
    silently(apply);
  }

  function apply() {
    reloadData();
    observeDetails();
    container = document.querySelector('.product-details .group-block-content');

    /* Alleen de eerste keer slopen (samenvatting/CTA). Daarna is dit een
       hertekening (free-gifts, levertijd, morph). */
    if (!applied) {
      reset();
      applied = true;
    }

    if (!container) return;

    noteVariantId(currentVariantId());
    if (staleConfiguratorCents) {
      var summary = container.querySelector('.bbv-summary');
      if (summary) summary.removeAttribute('data-configurator-main-line-cents');
    }

    restoreThemeQuantity();
    ctaLabel(container, LAYOUT);
    renderSummary();
  }

  function boot() {
    main = document.querySelector('.product-details');
    apply();

    /* De stepper werkt met stepUp()/stepDown() en vuurt geen change; het thema
       meldt de nieuwe waarde wel via zijn eigen event. */
    function onQuantityChange() {
      var field = document.querySelector('.bbv-qty-row [name="quantity"]');
      if (field) lastQuantity = parseInt(field.value, 10) || 1;
      silently(function () {
        renderSummary();
      });
    }
    function onConfiguratorPricing() {
      reloadData();
      if (!configuratorOwnsMainPrice()) {
        staleConfiguratorCents = true;
        silently(function () {
          renderSummary();
        });
        return;
      }
      staleConfiguratorCents = false;
      onQuantityChange();
    }
    document.addEventListener('quantity-selector:update', onQuantityChange);
    document.addEventListener('change', onQuantityChange);
    document.addEventListener('input', onQuantityChange);
    document.addEventListener('configurator-pricing-updated', onConfiguratorPricing);
    document.addEventListener('hds:buybox-extras-change', onQuantityChange);
    document.addEventListener('variant:update', function (event) {
      onVariantMorphed(event.detail && event.detail.resource);
    });
    document.addEventListener('hds:main-morphed', function () {
      onVariantMorphed(null);
    });
    document.addEventListener('addToCart:success', resetQuantityAfterAdd);
    document.addEventListener(BATCH_DONE_EVENT, onBatchDone);

    /* De +/− steppers van toebehoren/configurator werken met eigen knoppen en
       vuren geen change; de nieuwe waarde staat er pas na de klik. */
    document.addEventListener('click', function (event) {
      if (
        !event.target.closest(
          'variant-additional-products, free-gifts, .product-configurator-section, .bbv-qty-row, quantity-selector-component'
        )
      ) {
        return;
      }
      setTimeout(function () {
        silently(renderSummary);
      }, 60);
    });

    /* Horizon morpht de buybox bij een variantwissel — dan opnieuw toepassen.
       Observer alleen is te laat als .product-details zelf vervangen wordt. */
    if (!window.MutationObserver) return;
    var pending = null;
    /* Wijzigingen ín de kiezers van «Maak je vloer compleet» (rollende cijfers, open/dicht)
       melden zich al met hds:buybox-extras-change; daarvoor niet nog een keer tekenen. */
    var PICKERS = '[data-fc-slot], underlay-picker, plint-picker, profiel-picker, deurmat-picker';
    observer = new MutationObserver(function (records) {
      var outside = records.some(function (record) {
        var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !node || !node.closest(PICKERS);
      });
      if (!outside) return;
      clearTimeout(pending);
      pending = setTimeout(function () {
        silently(apply);
      }, 60);
    });
    observeDetails();
    if (main) observer.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
